// extracted by mini-css-extract-plugin
export default {"imageContainer":"PaymentFooter_imageContainer__b8ba7"};